/**
 * Mã field phép (leave_field) hard-code trên biểu mẫu phiếu nghỉ phép.
 * Các giá trị phải trùng khớp với cấu hình backend `annual-leave.field-codes.*`
 * (xem `workflow_be/src/main/resources/config/application.yml`).
 *
 * - Nhóm hiển thị (chỉ đọc, tự động điền từ quỹ phép của người soạn):
 *   PREVIOUS_REMAIN_LEFT (carryoverLeft), ANNUAL_LEAVE (annualTotal), REMAIN_DAYS (annualLeft)
 * - Nhóm nhập liệu (đọc để tính phép): LEAVE_DAYS, LEAVE_START_DATE, LEAVE_END_DATE
 *
 * Tách riêng khỏi `leave-fund.service.js` để module này không kéo theo chuỗi
 * phụ thuộc nặng (axios/store), giúp tái sử dụng và kiểm thử đơn vị dễ dàng.
 */
export const LEAVE_FIELD_CODES = Object.freeze({
	PREVIOUS_REMAIN_LEFT: "SO_PHEP_TON_CON_LAI", // carryoverLeft — số phép tồn còn lại
	ANNUAL_LEAVE: "SO_PHEP_NAM", // annualTotal — số phép năm
	REMAIN_DAYS: "SO_PHEP_CON_LAI", // annualLeft — số phép còn lại
	LEAVE_DAYS: "SO_NGAY_NGHI", // số ngày nghỉ
	LEAVE_START_DATE: "NGAY_BAT_DAU_NGHI", // ngày bắt đầu nghỉ (leave_start_date)
	LEAVE_END_DATE: "NGAY_KET_THUC_NGHI", // ngày kết thúc nghỉ
});

export default LEAVE_FIELD_CODES;
